import React from 'react';
import PropTypes from 'prop-types';

import Table from '../../ui/Table';

import columns from './columns';

class EventListTable extends React.PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      venue: PropTypes.string,
      dateTime: PropTypes.shape({
        date: PropTypes.string,
        time: PropTypes.string,
      }),
    })),
    locationQuery: PropTypes.object,
  };

  static defaultProps = {
    data: [],
    locationQuery: {},
  };

  render() {
    const {
      data,
      isCurated,
      isTara,
      locationQuery,
      ...rest
    } = this.props;

    return (
      <Table
        data={data}
        columns={columns}
        noDataText="No Events Found"
        pageSize={data.length}
        locationQuery={locationQuery}
        {...rest}
      />
    );
  }
}

export default EventListTable;



// WEBPACK FOOTER //
// ./src/components/features/EventListTable/EventListTable.js